
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSupport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"I18NLocaleCode"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soutien"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PageTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BannerText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BtnBannerLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BtnBannerLinkUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"NewWindow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondaryBtnBannerLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondaryBtnBannerLinkUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondaryBtnBannerTargetBlank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TitleSupport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ContactInfos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PhoneURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ShowChat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Sms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SmsUrl"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"TitlePwd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ContentText"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentText"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Text"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentButton"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"NewWindow"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SEO"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MetaTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MetaDescription"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":843}};
    doc.loc.source = {"body":"query getSupport($locale: I18NLocaleCode) {\n  soutien(locale: $locale) {\n    data {\n      attributes {\n        PageTitle\n        BannerText\n        BtnBannerLink\n        BtnBannerLinkUrl\n        NewWindow\n        secondaryBtnBannerLink\n        secondaryBtnBannerLinkUrl\n        secondaryBtnBannerTargetBlank\n        TitleSupport\n        ContactInfos{\n          Name\n          Phone\n          PhoneURL\n          Text\n          Email\n          ShowChat\n          Sms\n          SmsUrl\n        }\n        TitlePwd\n        ContentText{\n          __typename\n          \t... on ComponentContentText{\n              Text\n            }\n           \t... on ComponentContentButton{\n              Title\n              Url\n              NewWindow\n            }\n        }\n        SEO {\n          MetaTitle\n          MetaDescription\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getSupport"] = oneQuery(doc, "getSupport");
        
